import React from "react";
import { useParams } from "react-router-dom";
import ConfirmWrapperArea from "./ConfirmWrapperArea";

function Confirm() {
  const { ctype } = useParams();
  const { hash } = useParams();

  // Prevent infinite refresh loops by checking a flag
  React.useEffect(() => {
    if (!sessionStorage.getItem("hasReloaded")) {
      sessionStorage.setItem("hasReloaded", "true");
      window.location.reload();
    }
  }, []);

  return (
    <>
      <ConfirmWrapperArea ctype={ctype} hash={hash} />
    </>
  );
}

export default Confirm;
